import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    const token = this.authService.getToken();
    if (!token) return this.router.parseUrl('/login');

    if (this.authService.isTokenExpired()) {
      if (!this.authService.getRefreshToken()) {
        this.authService.clearAll();
        return this.router.parseUrl('/login');
      }
      // Token expired but refresh token exists — interceptor will handle refresh on next API call
    }

    return true;
  }

  canActivateChild(): boolean | UrlTree { return this.canActivate(); }
}
